import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Pod } from './pods.service';

@Injectable({
  providedIn: 'root'
})
export class AppropriatorsService {

  // Set up Appropriators BehaviorSubject
  private appropriatorsSource = new BehaviorSubject<Appropriator[]>([]);
  currentAppropriators = this.appropriatorsSource.asObservable();

  // Set up Appropriator BehaviorSubject
  private appropriatorSource = new BehaviorSubject<Appropriator>(null);
  currentAppropriator = this.appropriatorSource.asObservable();

  private appropriatorPodsSource = new BehaviorSubject<AppropriatorPod[]>([]);
  currentAppropriatorPods = this.appropriatorPodsSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  getAppropriators() {
    this.http.get<Appropriator[]>(`${this.baseUrl}api/appropriator/search`).subscribe(
      response => {
        if (response) {
          this.changeAppropriators(response);
        }
      },
      error => console.error(error)
    );
  }

  getAppropriator(id: number) {
    this.http.get<Appropriator>(`${this.baseUrl}api/appropriator/${id}`).subscribe(
      response => {
        if (response) {
          this.changeAppropriator(response);
        }
      },
      error => console.error(error)
    );
  }

  postAppropriator(name, address, phonenumber, email) {
    this.http.post(`${this.baseUrl}api/appropriator/?name=${name}&address=${address}&phonenumber=${phonenumber}&email=${email}`, {}, {observe: 'response'}).subscribe(
      response => {
        if(response.status === 200) {
          this.getAppropriators();
        }
      },
      error => console.log(error)
    );
  }

  putAppropriator(editApp) {
    this.http.put(`${this.baseUrl}api/appropriator/`, editApp, {observe: 'response'}).subscribe(
      response => {
        if(response.status === 200) {
          this.getAppropriators();
        }
      },
      error => console.log(error)
    );
  }

  getAppropriatorPods() {
    this.http.get<AppropriatorPod[]>(`${this.baseUrl}api/appropriator/pods`).subscribe(
      response => {
        if (response) {
          this.changeAppropriatorPods(response);
        }
      },
      error => console.error(error)
    );
  }


  // Update Appropriators BehaviorSubject
  changeAppropriators(appropriators) {
    this.appropriatorsSource.next(appropriators);
  }

  // Update Appropriator BehaviorSubject
  changeAppropriator(appropriator) {
    this.appropriatorSource.next(appropriator);
  }

  // Update AppropriatorPods BehaviorSubject
  changeAppropriatorPods(appropriatorPods) {
    this.appropriatorPodsSource.next(appropriatorPods);
  }
}


export interface Appropriator {
  appropriatorId: number,
  name: string,
  address: string,
  phoneNumber: string,
  email: string
}

export interface AppropriatorPod {
  appropriatorId: number,
  name: string,
  address: string,
  phoneNumber: string,
  email: string,
  pods: Pod[]
}
